<section class="auth-page">
  <div class="auth-card ecb-card">
    <div class="auth-visual">
      <a routerLink="/" class="ecb-logo">
        <span class="ecb-logo-mark">ECB</span>
        <span class="ecb-logo-text">
          <span>ECB</span>
          <small>TRAINING SERVICES</small>
        </span>
      </a>

      <h1>Student Login</h1>
      <p>Login to view your purchases and profile.</p>

      <div class="auth-badge">
        <i class="fa fa-lock"></i>
        <span>Secure training portal access</span>
      </div>
    </div>

    <div class="auth-form">
      <h2>Student Login</h2>
      <p class="ecb-muted">Use your ECB Training account credentials.</p>

      <!-- Error Message -->
      <div class="login-error-box" *ngIf="errorMessage">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <label>Email Address</label>
      <input class="ecb-form-control" [(ngModel)]="email" placeholder="customer&#64;ecbtraining.local"
        [class.input-error]="errorMessage" (keyup.enter)="login()" (input)="clearError()">

      <label>Password</label>
      <input class="ecb-form-control" type="password" [(ngModel)]="password" placeholder="Enter password"
        [class.input-error]="errorMessage" (keyup.enter)="login()" (input)="clearError()">

      <button class="ecb-btn-primary w-100 mt-3" type="button" [disabled]="isLoading" (click)="login()">

        <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-sign-in'"></i>
        {{ isLoading ? 'Logging in...' : 'Login' }}
      </button>

      <a routerLink="/auth/register" class="register-link">Create a student account</a>
    </div>
  </div>
</section>